<template>

    <div class="stages-detail-page admin-page">
        <Header></Header>
        <vue-ins-progress-bar></vue-ins-progress-bar>
        <section class="contact-section">
            <div class="container">
                <div class="row admin-bar">
                    <div class="col-md-5" style="margin: 0 auto;">
                        <router-link class="next-icon prev-b" :to="`/admin/artist/`+userId+`/stages`"><img src="@/assets/img/prev.svg"/> Stages List</router-link>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-md-5" style="margin: 0 auto;">
                        <h2>New Stage</h2>
                        <form class="form" v-on:submit.prevent="uploadImgages" enctype="multipart/form-data">
                            <div class="input-field form-input">
                                <label for="your-title">Title *</label>
                                <input type="text" placeholder="Add a title" v-model="title" id="your-title" v-on:blur="titleFuntion(title)">
                                <p class="error-input" v-if="titleFlag">Title is required</p>
                            </div>
                            <div class="input-field form-input">
                                <label for="youtubeurl">You Tube Link *</label>
                                <input type="text" placeholder="You Tube Link" v-model="youtubeurl" id="youtubeurl">
                            </div>
                            <div class="input-file-field form-input">
                                <p>Video Cover Image *</p>
                                <label for="video_image">
                                    <span>{{videoCoverImage}}</span>
                                    <span>Choose File</span>
                                </label>
                                <input type="file" id="video_image" ref="videoImageFile" v-on:change="handleVideoCoverUpload">
                            </div>
                            <div class="input-tags-field form-input">
                                <label>Skills *</label>
                                <tags-input element-id="tags"
                                            v-model="selectedTags"
                                            :only-existing-tags="true"
                                            :delete-on-backspace="true"
                                            :typeahead-hide-discard="true"
                                            @tags-updated="tagFuntion"
                                            :existing-tags="$options.skills"
                                            :typeahead="true"></tags-input>
                                <p class="error-input" v-if="tagsFlag">Tags are required</p>
                            </div>
                            <div class="input-textarea-field form-input">
                                <label for="your-description">Description *</label>
                                <textarea placeholder="Tell us about your stage..." id="your-description" v-model="description" v-on:blur="descriptionFuntion(description)" style="min-height: 150px;"></textarea>
                                <p class="error-input" v-if="descriptionFlag">Description is required</p>
                            </div>
                            <div class="input-field form-input">
                                <label for="isfeatured">Is Featured</label>
                                <input type="checkbox" v-model="isfeatured" id="isfeatured">
                            </div>
                            <div class="input-submit">
                                <button type="submit" v-if="!FormSubmited">SUBMIT</button>
                                <span v-if="FormSubmited">SUBMIT...</span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
        <Footer></Footer>
    </div>
</template>

<style>
    @import "../../../assets/css/tagsinput.css";
</style>

<script>
    import Vue from 'vue'
    import Header from '../Header'
    import Footer from '../Footer'
    import router from '../../../router'
    import VoerroTagsInput from '@voerro/vue-tagsinput'
    import VueInsProgressBar from 'vue-ins-progress-bar'
    import axios from 'axios'
    import VueToast from 'vue-toast-notification'
    import 'vue-toast-notification/dist/index.css'
    Vue.use(VueToast)
    import skills from '@/assets/skills.json'
    const options = {
        position: 'fixed',
        show: true,
        height: '5px'
    }
    Vue.use(VueInsProgressBar, options)
    export default {
        name: 'StageCreate',
        skills: skills,
        components: {
            'Header': Header,
            'Footer': Footer,
            'tags-input': VoerroTagsInput
        },
        data () {
            // router.push({ name: 'Login' })
            var userdata = localStorage.getItem('cbs_admin_usertoken')
            if(userdata){
                userdata = JSON.parse(userdata)
            }
            return {
                msg: 'Welcome to Your Vue.js App',
                title: '',
                youtubeurl: '',
                titleFlag: false,
                tagsFlag: false,
                description: '',
                descriptionFlag: false,
                stageid: '',
                videoFile: 'Video file',
                FormSubmited: false,
                isfeatured: false,
                userData: userdata,
                // videoImageFile: '',
                videoId: '',
                videoCoverImage: 'Cover Image',
                userId: router.history.current.params.id,
                tags: [],
                selectedTags: []
            }
        },
        mounted () {
            // this.$insProgress.start()
        },
        methods: {
            titleFuntion(msg){
                if (!msg) {
                    this.titleFlag = true
                } else {
                    this.titleFlag = false
                }
            },
            tagFuntion(msg){
                if (!this.selectedTags.length) {
                    this.tagsFlag = true
                } else {
                    this.tagsFlag = false
                    var tags = []
                    this.selectedTags.map(function(value, key) {
                        tags.push(value.value)
                    })
                    this.tags = tags
                }
            },
            descriptionFuntion(msg){
                if (!msg) {
                    this.descriptionFlag = true
                } else {
                    this.descriptionFlag = false
                }
            },
            createStageForm(){
                try {
                    axios.post('/createstage', {
                        title: this.title,
                        description: this.description,
                        youtubeurl: this.youtubeurl,
                        isfeatured: this.isfeatured,
                        tags: this.tags,
                        videoId: this.videoId,
                        userId: this.userId
                    },{
                        headers: {
                            "content-type": "application/json",
                            "x-api-key": this.userData.token
                        }
                    }).then(res => {
                        this.FormSubmited = false
                        this.$insProgress.finish()
                        Vue.$toast.open(
                            {
                                message: 'Stage created successfully!',
                                type: 'success',
                                position: 'top-right'
                                // all other options
                            }
                        )
                        this.title = this.description = this.selectedTags = this.videoImageFile = this.videoCoverImage = ''
                    }).catch(err => {
                        this.FormSubmited = false
                        console.log(err)
                    })
                } catch (e) {
                    this.FormSubmited = false
                    console.log(e)
                }
            },
            handleFileUpload(){
                this.file = this.$refs.file.files[0]
                this.videoFile = this.$refs.file.files[0].name
                console.log(this.$refs.file.files[0].name)
            },
            handleVideoCoverUpload(){
                this.videoImageFile = this.$refs.videoImageFile.files[0]
                this.videoCoverImage = this.$refs.videoImageFile.files[0].name
                console.log(this.$refs.videoImageFile.files[0].name)
            },
            async uploadImgages () {
                if(this.title && this.description && this.selectedTags && this.videoImageFile){
                    this.FormSubmited = true
                    this.$insProgress.start()
                    const formData = new FormData()
                    // formData.append('videourl', this.file)
                    formData.append('videoImageFile', this.videoImageFile)
                    // formData.append('videoName', this.videoFile)
                    formData.append('videoImageName', this.videoCoverImage)
                    try {
                        axios.post('/videoupload', formData,{
                            headers: {
                                "content-type": "application/json",
                                "x-api-key": this.userData.token
                            }
                        }).then(res => {
                            this.videoId = res.data.videoId
                            this.createStageForm()
                            console.log(res)
                        }).catch(err => {
                            console.log(err)
                        })
                    } catch (e) {
                        console.log(e)
                    }
                } else {
                    Vue.$toast.open(
                        {
                            message: 'Please fill all the fields!',
                            type: 'error',
                            position: 'top-right'
                            // all other options
                        }
                    )
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/admin/stages/Create.vue